__turbopack_context__.v({
  "actionLink": "VQ-ddq_actionLink",
  "details": "VQ-ddq_details",
  "root": "VQ-ddq_root",
});
